import api from '@/utils/api';

/**
 * Update Product Category
 * @param {number} companyId The company
 * @param {object} categoryData The category data
 * @returns {Promise} The API response
 */
const updateProductCategoryApi = (companyId, categoryData) =>
  api.patch(
    `/company/${companyId}/product-category/${categoryData.id}`,
    categoryData,
  );

export default updateProductCategoryApi;
